import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { CopyOnly } from "services/cms/models/copyOnly";

import richTextResolver, { ResolvedRichText } from "./richTextResolver";

export type ResolvedCopyOnly = {
    backgroundColor: string;
    textForegroundColor: string;
    content: ResolvedRichText;
    type: ContentTypeCodenames.CopyOnly;
    codename: string;
};

const copyOnlyResolver = (data: CopyOnly): ResolvedCopyOnly => {
    return {
        backgroundColor: data.elements.backgroundColor.value,
        textForegroundColor: data.elements.textForegroundColor.value,
        content: richTextResolver({
            html: data.elements.content.value,
            linkedItems: data.elements.content.linkedItems,
        }),
        codename: data.system.codename,
        type: ContentTypeCodenames.CopyOnly,
    };
};

export default copyOnlyResolver;
